import { getCookie } from './cookies';

export const current_unit_slug = () => getCookie('current_unit_slug');
